import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { formatDate } from './articles';

/** Lista de artículos con filetes: miniatura, tipo y fecha, título y descripción. */
const ArticleRows = ({ items }) => (
  <ul className="border-b border-slate-300">
    {items.map((a) => (
      <li key={a.url} className="border-t border-slate-300">
        <Link to={a.url} className="group flex items-start justify-between gap-6 py-6">
          {a.image && (
            <img src={a.image} alt="" width="1536" height="864" loading="lazy" className="hidden sm:block w-44 h-auto aspect-[16/9] object-cover flex-shrink-0" />
          )}
          <span className="flex-1">
            <span className="block text-xs font-semibold uppercase tracking-[0.14em] text-slate-500">
              {a.kind} · {formatDate(a.updated)}
            </span>
            <span className="mt-2 block text-lg font-semibold leading-snug text-slate-900 group-hover:text-primary-700 transition-colors">{a.title}</span>
            <span className="mt-1.5 block text-[15px] leading-relaxed text-slate-600">{a.text}</span>
          </span>
          <ArrowRight className="mt-7 w-5 h-5 flex-shrink-0 text-slate-400 group-hover:text-primary-700 group-hover:translate-x-1 transition" />
        </Link>
      </li>
    ))}
  </ul>
);

export default ArticleRows;
